import React from 'react'

const FullWidthImageGrid = ({ data }) => {
    const { topLeftImage, topRightImage, bottomLeftImage, bottomRightImage } = data

    const images = [
        topLeftImage, 
        topRightImage, 
        bottomLeftImage, 
        bottomRightImage
    ];

    return (
        <section className="full-width-image-grid">
            { images ? images.map((img, i) => {
                return (
                    <div key={i} className={`grid-item item${i + 1}`}>
                        <img 
                            src={img?.localFile?.childImageSharp?.fluid.src}
                        />
                    </div>
                )
            }) : null }
        </section>
    )
}

export default FullWidthImageGrid
